import React, { useState, useEffect } from "react";
import axios from "axios";
import "./myorders.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
const Myorders = ({ logout, user, API_URL }) => {

    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [monthFilter, setMonthFilter] = useState(""); // "YYYY-MM" или "" = все
    const fetchOrders = async () => {
        try {
            const response = await axios.post(`${API_URL}/getRequestsWeb`);
            const data = Array.isArray(response.data) ? response.data : [];
            data.sort((a, b) => Number(b.orderNumber) - Number(a.orderNumber));
            setOrders(data);
        } catch (error) {
            console.error("Ошибка загрузки заказов:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrders();
    }, [API_URL]);

    useEffect(() => {
        const socketUrl = API_URL.replace(/\/api\/?$/, "");
        const socket = io(socketUrl);

        socket.on("calendar:update", () => {
            fetchOrders();
        });

        return () => socket.disconnect();
    }, [API_URL]);

    // Поиск: № заказа, название (гость / компания), имена всех гостей
    function matchesSearch(order) {
        const q = searchQuery.trim().toLowerCase().replace(/^№/, "");
        if (!q) return true;

        if (String(order.orderNumber ?? "").includes(q)) return true;
        if (order.title && order.title.toLowerCase().includes(q)) return true;
        if (Array.isArray(order.guests)) {
            return order.guests.some((g) => g.name && g.name.toLowerCase().includes(q));
        }
        return false;
    }

    // Месяц — по дате начала тура ("2026-10-08" → "2026-10")
    const MONTHS_FULL = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
    const monthKey = (order) => (order.dateStart ? String(order.dateStart).slice(0, 7) : "");
    const monthLabel = (key) => {
        const [y, m] = key.split("-");
        return `${MONTHS_FULL[Number(m) - 1]} ${y}`;
    };

    const myOrders = orders.filter((order) => order.manager === user?.fullname);
    const monthOptions = [...new Set(myOrders.map(monthKey).filter(Boolean))].sort().reverse();

    const filteredOrders = myOrders
        .filter((order) => !monthFilter || monthKey(order) === monthFilter)
        .filter(matchesSearch);
    const hasFilters = searchQuery || monthFilter;

    // Деньги: 12345 → "12 345"
    function formatMoney(amount) {
        return Number(amount || 0).toLocaleString("ru-RU");
    }

    // Инициалы менеджера
    function getInitials(name) {
        if (!name) return "—";
        const parts = name.trim().split(/\s+/);
        if (parts.length > 1) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        return (name.trim()[0] + name.trim()[name.trim().length - 1]).toUpperCase();
    }

    // Статус/тип заказа → { label, cls }
    function getStatus(order) {
        if (order.status === 1) {
            return { label: "Отменен", cls: "status" };
        }
        // if (order.type === "sharetour")
        //     return { label: "Групповой", cls: "share" };
        const payLabels = {
            cash: { label: "Наличка", cls: "paid" },
            terminal: { label: "Терминал", cls: "transfer" },
            transfer: { label: "Перечисление", cls: "transfer" },
            debt: { label: "Долг", cls: "debt" },
        };
        return payLabels[order.paymentType] || { label: "—", cls: "debt" };
    }

    // "YYYY-MM-DD" → "11 июн 2026"
    const RU_M = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
    function formatDate(dateStr) {
        if (!dateStr) return "—";
        const [y, m, d] = dateStr.split("-");
        return `${Number(d)} ${RU_M[Number(m) - 1]} ${y}`;
    }

    const totalSum = filteredOrders.reduce((sum, o) => sum + (Number(o.grandTotal) || 0), 0);

    const handleUpdate = async (orderNumber, type, status) => {
        const payload = {
            orderNumber,
            type,
            status,
            requestedBy: user?.fullname,
            requestedRole: user?.role,
        };
        const confirmDelete = window.confirm(`${status === 0 ? "Активировать?" : "Отменять?"}`);
        if (!confirmDelete) return;
        try {
            await axios.post(`${API_URL}/updateStatus`, payload);
            if (status === 0) {
                toast.success("Изменения сохранены");

            } else {
                toast.error("Тур отменен");
            }
            setOrders(prev =>
                prev.map(o => o.orderNumber === orderNumber ? { ...o, status } : o)
            );
        } catch (err) {
            console.error("Ошибка при сохранении:", err);
            toast.error("Не удалось сохранить изменения");
        }
    };

    // ─── Публикация (sharetour, фиксированный максимум — 4 места) ─
    function publishOrder(order) {
        const ok = window.confirm("Опубликовать заказ на сайте?");
        if (!ok) return;

        axios
            .post(`${API_URL}/publishOrder`, {
                orderId: order.id,
                orderType: order.type,
            })
            .then(() => {
                toast.success("Опубликовано на сайте");
                setOrders(prev =>
                    prev.map(o =>
                        (o.id === order.id && o.type === order.type)
                            ? { ...o, isPublished: true, webTotalSeats: 4 }
                            : o
                    )
                );
            })
            .catch(() => toast.error("Ошибка публикации"));
    }

    // ─── Снятие с публикации ───────────────────────────────────────
    function unpublishOrder(order) {
        const ok = window.confirm("Снять заказ с публикации на сайте?");
        if (!ok) return;

        axios
            .post(`${API_URL}/unpublishOrder`, {
                orderId: order.id,
                orderType: order.type,
            })
            .then(() => {
                toast.success("Снято с публикации");
                setOrders(prev =>
                    prev.map(o =>
                        (o.id === order.id && o.type === order.type)
                            ? { ...o, isPublished: false }
                            : o
                    )
                );
            })
            .catch(() => toast.error("Ошибка"));
    }

    return (
        <div className="orders">
            <div className="orders-flex">
                {/* Шапка */}
                <div className="orders-head">
                    <div className="orders-head__left">
                        <h2>Мои заказы</h2>
                        <div className="orders-search">
                            <i className="fa-solid fa-magnifying-glass"></i>
                            <input
                                type="text"
                                placeholder="ФИО / Номер заказа"
                                value={searchQuery}
                                onChange={e => setSearchQuery(e.target.value)}
                            />
                            {searchQuery && (
                                <i
                                    className="fa-solid fa-xmark"
                                    onClick={() => setSearchQuery("")}
                                ></i>
                            )}
                        </div>
                        <select className="orders-filter" value={monthFilter} onChange={(e) => setMonthFilter(e.target.value)}>
                            <option value="">Все месяцы</option>
                            {monthOptions.map((k) => <option key={k} value={k}>{monthLabel(k)}</option>)}
                        </select>
                        {hasFilters && (
                            <button
                                type="button"
                                className="orders-filter-reset"
                                onClick={() => { setSearchQuery(""); setMonthFilter(""); }}
                            >
                                Сбросить
                            </button>
                        )}
                    </div>
                    <div className="orders-head__stats">
                        <span>{filteredOrders.length} заказов</span>
                        <span>·</span>
                        <span>{formatMoney(totalSum)}$ всего</span>
                    </div>
                    <div className="home-sec1-box3">
                        <Link className="link" to="/addrequest">
                            <i className="fa-solid fa-square-plus"></i>
                            Добавить заказ
                        </Link>
                    </div>
                </div>

                {/* Список */}
                <div className="orders-list">
                    {loading ? (
                        <div className="orders-empty">Загрузка...</div>
                    ) : filteredOrders.length === 0 ? (
                        <div className="orders-empty">
                            {hasFilters ? "Ничего не найдено" : "Заказов пока нет"}
                        </div>
                    ) : (
                        filteredOrders.map(order => {
                            const status = getStatus(order);
                            return (
                                <div key={`${order.type}-${order.id}`} className={`orow orow--${status.cls}`}>
                                    <div className="orow__num">№{order.orderNumber}</div>

                                    <div className="orow__main">
                                        <div className="orow__title">{order.title}</div>
                                        <div className="orow__tour">{order.tour} · {order.participantsCount} чел.</div>
                                    </div>

                                    <div className="orow__date">
                                        {formatDate(order.dateStart)}
                                        {order.dateEnd && order.dateEnd !== order.dateStart ? ` – ${formatDate(order.dateEnd)}` : ""}
                                    </div>
                                    <span className="orow__pill">{status.label}</span>

                                    <div className="orow__manager">
                                        <span className="orow__avatar">{getInitials(order.manager)}</span>
                                        <span>{order.manager}</span>
                                    </div>

                                    {order.type === "sharetour" ? (
                                        order.isPublished ? (
                                            <div className="orow__published">
                                                <span className="orow__published-pill" title="Опубликовано на сайте">
                                                    <i className="fa-solid fa-globe"></i>
                                                    {order.webTakenSeats ?? 0}/{order.webTotalSeats ?? 4} мест
                                                </span>
                                                <button
                                                    type="button"
                                                    className="orow__publish-icon orow__publish-icon--remove"
                                                    onClick={() => unpublishOrder(order)}
                                                >
                                                    <i className="fa-solid fa-xmark"></i>
                                                </button>
                                            </div>
                                        ) : (
                                            <button
                                                type="button"
                                                className="orow__publish"
                                                onClick={() => publishOrder(order)}
                                            >
                                                <i className="fa-solid fa-globe"></i> Опубликовать
                                            </button>
                                        )
                                    ) : (
                                        <div className="orow__publish-placeholder" />
                                    )}

                                    <div className="orow__sum">{formatMoney(order.grandTotal)}$</div>
                                    {
                                        order.status === 0
                                            ? (
                                                <button className="orow__btn_status true" onClick={() => handleUpdate(order.orderNumber, order.type, 1)}>Отменить</button>
                                            )
                                            : order.status === 1 ? (
                                                <button className="orow__btn_status false" onClick={() => handleUpdate(order.orderNumber, order.type, 0)}>Активировать</button>
                                            ) : null
                                    }

                                    <Link className="orow__more" to={`/tourdetails/${order.orderNumber}`}>
                                        Подробнее <i className="fa-solid fa-arrow-right-long"></i>
                                    </Link>

                                </div>
                            );
                        })
                    )}
                </div>

            </div>
        </div >
    );
};

export default Myorders;